var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "40px",
    viewBox: "0 0 57 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2971C51B-A0F6-46A1-B4B0-6F0CDE2F2CA4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-1",
    transform: "translate(-223.000000, -1734.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(222.000000, 1729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wifi-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.43484731,13.6071429 C9.12370078,6.96428571 18.3331209,2.85714286 28.5044533,2.85714286 C38.6757857,2.85714286 47.8852058,6.96428571 54.5740593,13.6071429 C55.1351748,14.1607143 56.034741,14.1607143 56.5869499,13.5982143 C57.1391589,13.0357143 57.1391589,12.1339286 56.5780433,11.5803571 C49.3726073,4.41964286 39.4506596,0 28.5044533,0 C17.558247,0 7.63629928,4.41964286 0.421956657,11.5803571 C-0.13915888,12.1339286 -0.13915888,13.0357143 0.413050061,13.5982143 C0.965259003,14.1607143 1.86482518,14.1607143 2.42594072,13.6071429 L2.43484731,13.6071429 Z M28.5044533,17.1428571 C34.7836034,17.1428571 40.4749181,19.6875 44.598672,23.8125 C45.1597875,24.3660714 46.0593537,24.3660714 46.6115626,23.8125 C47.1637716,23.2589286 47.1637716,22.3482143 46.6115626,21.7946429 C41.9712262,17.1607143 35.5762904,14.2946429 28.5044533,14.2946429 C21.4326162,14.2946429 15.0376804,17.1607143 10.397344,21.7946429 C9.83622845,22.3482143 9.83622845,23.2589286 10.397344,23.8125 C10.9584595,24.3660714 11.8580257,24.375 12.4102346,23.8125 C16.5339885,19.6875 22.2253032,17.1428571 28.5044533,17.1428571 Z M28.5044533,31.4285714 C30.078526,31.4285714 31.354564,32.7077579 31.354564,34.2857143 C31.354564,35.8636707 30.078526,37.1428571 28.5044533,37.1428571 C26.9303806,37.1428571 25.6543426,35.8636707 25.6543426,34.2857143 C25.6543426,32.7077579 26.9303806,31.4285714 28.5044533,31.4285714 Z M28.5044533,40 C31.6525986,40 34.2046746,37.4416271 34.2046746,34.2857143 C34.2046746,31.1298014 31.6525986,28.5714286 28.5044533,28.5714286 C25.356308,28.5714286 22.804232,31.1298014 22.804232,34.2857143 C22.804232,37.4416271 25.356308,40 28.5044533,40 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiLight);
export default __webpack_public_path__ + "static/media/wifi-light.3a19203f3b73f899fac6f83fe45950c0.svg";
export { ForwardRef as ReactComponent };